var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 116.39 100.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{fill:#2e5497;}.cls-3{clip-path:url(#clip-path);}.cls-4{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.9px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.76,
    y: 26.03,
    width: 50.53,
    height: 51.54
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-2",
    d: "M84.31,0H32.07a5.14,5.14,0,0,0-4.44,2.56L1.48,47.85a5.11,5.11,0,0,0,0,5.13L27.63,98.26a5.14,5.14,0,0,0,4.44,2.56H84.31a5.12,5.12,0,0,0,4.44-2.56L114.9,53a5.11,5.11,0,0,0,0-5.13L88.75,2.56A5.12,5.12,0,0,0,84.31,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-4",
    d: "M67,76.61V74a2.59,2.59,0,0,0-1.31-2.27l-4.64-2.62a1.47,1.47,0,0,1-.74-1.28V66.24a1.58,1.58,0,0,1,.45-1.1,4.92,4.92,0,0,0,1.36-3.41V58.26a4.81,4.81,0,1,0-9.61,0v3.47a4.88,4.88,0,0,0,1.36,3.41,1.58,1.58,0,0,1,.45,1.1v1.57a1.47,1.47,0,0,1-.74,1.28L49,71.71A2.6,2.6,0,0,0,47.66,74v2.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-4",
    d: "M46.13,67.24A1.47,1.47,0,0,1,45.39,66V64.39a1.6,1.6,0,0,1,.45-1.1,4.93,4.93,0,0,0,1.37-3.41V56.41a4.81,4.81,0,1,0-9.62,0v3.47A5,5,0,0,0,39,63.29a1.63,1.63,0,0,1,.46,1.1V66a1.47,1.47,0,0,1-.74,1.28L34,69.85a2.61,2.61,0,0,0-1.31,2.27v4.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-4",
    d: "M67.92,67.24A1.48,1.48,0,0,0,68.65,66V64.39a1.58,1.58,0,0,0-.45-1.1,5,5,0,0,1-1.36-3.41V56.41a4.81,4.81,0,1,1,9.62,0v3.47a4.93,4.93,0,0,1-1.37,3.41,1.67,1.67,0,0,0-.45,1.1V66a1.47,1.47,0,0,0,.74,1.28L80,69.85a2.61,2.61,0,0,1,1.32,2.27v4.49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-4",
    d: "M68.58,38.28H47.82l-4.24,8.1V27h25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-4",
    d: "M65.43,42.91h5l2.81,3.62V37.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-4",
    d: "M51.11,42.91l3.55.15L56,46.53l3.09-3.62h2.26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp2);
export default __webpack_public_path__ + "static/media/hp_2.3b671a20fbf64d9ee84606fe5240143a.svg";
export { ForwardRef as ReactComponent };